import React from "react"
import { brandPagePath } from "../../../../root/routing/urls"
import BrandHeader, {
  BrandHeaderProps,
} from "../../../../ui/organisms/BrandHeader"

interface Props {
  item: any
}

const toBrandHeaderProps = (item: any): BrandHeaderProps => ({
  logo: item.header?.logo,
  backgroundColor: item.header?.backgroundColor?.hex,
  link: brandPagePath(item.slug?.current),
  logoHeight: item.header?.logoHeight,
  textColor: item.header?.textColor?.hex,
})

const CmsBrandHeader = ({ item }: Props) => {
  const data = toBrandHeaderProps(item)
  return <BrandHeader {...data} />
}

export default CmsBrandHeader
